import { render, staticRenderFns } from "./SvgFrontFramePassportGlobal.vue?vue&type=template&id=e7d3d27a&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports